var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-4 has-background-white mb-0" }, [
    _c("div", { staticClass: "buttons" }, [
      _vm.hasPendientes &&
      (_vm.cantDocumentos == 0 || !_vm.seleccionaSoloSusDocumentosPendientes)
        ? _c(
            "button",
            {
              staticClass: "button is-primary",
              class: { "is-loading": _vm.isFetching },
              on: {
                click: function ($event) {
                  return _vm.$emit("firmar-pendientes")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-file-signature fa-fw" }),
              _vm._v(" Firmar mis pendientes"),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPendientes &&
      _vm.cantDocumentos > 0 &&
      _vm.seleccionaSoloSusDocumentosPendientes
        ? _c(
            "button",
            {
              staticClass: "button is-primary",
              class: { "is-loading": _vm.isFetching },
              on: {
                click: function ($event) {
                  return _vm.$emit("firmar-pendientes")
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-file-signature fa-fw" }),
              _vm._v(
                " Firmar " +
                  _vm._s(_vm.cantDocumentos) +
                  " seleccionado" +
                  _vm._s(_vm.cantDocumentos > 1 ? "s" : "")
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasDocumentosSelected,
              expression: "hasDocumentosSelected",
            },
          ],
          staticClass: "button is-light",
          on: {
            click: function ($event) {
              return _vm.$emit("download")
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-download fa-fw" }),
          _vm._v(
            " Descargar " +
              _vm._s(_vm.cantDocumentos) +
              " seleccionado" +
              _vm._s(_vm.cantDocumentos > 1 ? "s" : "")
          ),
        ]
      ),
      _vm._v(" "),
      _c("a", { staticClass: "button is-light", on: { click: _vm.refresh } }, [
        _c("i", { staticClass: "fas fa-sync fa-fw" }),
        _vm._v(" Recargar"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }